import React from 'react';
import './StageBar.scss';

interface StageBarProps {
  retained: number;
  lost: number;
  retainedColor: string;
  retainedLabel?: string;
  lostLabel?: string;
  small?: boolean;
}

export const StageBar: React.FC<StageBarProps> = ({
  retained,
  lost,
  retainedColor,
  retainedLabel,
  lostLabel,
  small = false,
}) => {
  const total = retained + lost;
  const retainedPct = total > 0 ? (retained / total) * 100 : 100;
  const lostPct = total > 0 ? (lost / total) * 100 : 0;

  return (
    <div className={`ovp-stagebar ${small ? 'ovp-stagebar--small' : ''}`}>
      {retainedPct > 0 && (
        <div
          className="ovp-stagebar__segment ovp-stagebar__segment--keep"
          style={{ width: `${retainedPct}%`, background: retainedColor }}
        >
          {!small && retainedLabel && <span className="ovp-stagebar__label">{retainedLabel}</span>}
        </div>
      )}
      {lostPct > 0 && (
        <div
          className="ovp-stagebar__segment ovp-stagebar__segment--lost"
          style={{ width: `${lostPct}%` }}
        >
          {!small && lostLabel && <span className="ovp-stagebar__label">{lostLabel}</span>}
        </div>
      )}
    </div>
  );
};
